import axios from '@/axios.js'
import network from '../../http/requests/network/index.js'

export default {
  fetchNetworks(context) {
    return new Promise((resolve, reject) => {
      network
        .getNetworks()
        .then(response => {
          context.commit('SET_NETWORKS', response.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        })
    })
  },

  setActiveNetwork({ commit }, network) {
    commit('SET_ACTIVE_NETWORK', network)
  },

  createNetwork({ dispatch, commit }, name) {
    return new Promise((resolve, reject) => {
      network
        .createNetwork(name)
        .then(response => {
          if (response.data.status == 0) {
            dispatch("fetchNetworks").then((fetchResponse) => {
              resolve(response);
            }).catch(reject);
          } else {
            reject(response.data.error)
          }
        })
        .catch(error => {
          reject(error);
        })
    })
  },

  async togglePremiumNetwork(context, { network_id, state }) {
    const response = await network.togglePremiumNetwork(network_id, state)
    return response
  },

  deleteNetwork({ dispatch, commit }, networkID) {
    return new Promise((resolve, reject) => {
      network.
        deleteNetwork(networkID)
        .then(response => {
          if (response.data.status == 0) {
            dispatch("fetchNetworks").then((fetchResponse) => {
              resolve(response);
            }).catch(reject);
          } else {
            reject(response.data.message)
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateNetwork({ commit }, inputObj) {
    return new Promise((resolve, reject) => {
      if (!inputObj.id) {
        reject();
        return;
      }

      network.
        updateNetwork(inputObj.id, inputObj)
        .then(response => {
          if (response.data.data) {
            commit('UPDATE_NETWORK', Object.assign({ id: inputObj.id }, response.data.data))
            resolve(response)
          } else {
            reject(response.data.error)
          }
        }).catch(error => {
          reject(error);
        })
    });
  },
  fetchNetworkOverviewGraph({ commit }, networkID) {
    return new Promise((resolve, reject) => {
      network.
        getOverview(networkID)
        .then(response => {
          let responseSeries = {
            name: 'Players',
            data: response.data,
          };
          commit('UPDATE_NETWORK_OVERVIEW_GRAPH', [networkID, responseSeries]);
          resolve(responseSeries);
        })
        .catch(error => {
          reject(error);
        })
    })
  },
  fetchNetworkPlayersGraph({ commit }, params) {
    return new Promise((resolve, reject) => {
      network.
        getPlayersGraph(params.id, params.points, params.period)
        .then(response => {
          let responseSeries = {
            name: 'Players',
            data: response.data,
          };
          commit('UPDATE_NETWORK_PLAYERS_GRAPH', [params.id, responseSeries]);
          resolve(responseSeries);
        })
        .catch(error => {
          reject(error);
        })
    })
  },


  fetchSubUsers({ commit }, network_id) {
    return new Promise((resolve, reject) => {
      network
        .getSubUsers(network_id)
        .then(response => {
          commit('SET_SUB_USERS', response.data.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  createSubUser({ commit }, { network_id, email, perms }) {
    return new Promise((resolve, reject) => {
      network
        .createSubUser(network_id, email, perms)
        .then(response => {
          if (response.data.data) {
            commit('ADD_SUB_USER', response.data.data)
            resolve(response)
          } else {
            reject(response.data.error)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  updateSubUser({ commit }, { network_id, user_id, perms }) {
    return new Promise((resolve, reject) => {
      network
        .updateSubUser(network_id, user_id, perms)
        .then(response => {
          if (response.data) {
            commit('UPDATE_SUB_USER', {
              user_id: user_id,
              perms: perms

            })
            resolve(response)
          } else {
            reject(response.data.error)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },


  deleteSubUser({ commit }, { network_id, user_id }) {
    return new Promise((resolve, reject) => {
      network
        .deleteSubUser(network_id, user_id)
        .then(response => {
          if (response.data) {
            commit('REMOVE_SUB_USER', user_id)
            resolve(response)
          } else {
            reject(response.data.error)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  fetchNetworkIPFirewallEntries({ commit }, network_id) {
    return new Promise((resolve, reject) => {
      network
        .getNetworkFirwallEntries(network_id)
        .then(response => {
          commit('SET_NETWORK_FIREWALL_ENTRIES', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  createOrUpdateIPFirewallEntry({ commit }, { network_id, cidr, whitelist, id }) {
    return new Promise((resolve, reject) => {
      network
        .createOrUpdateIPFirewallEntry(network_id, cidr, whitelist, id)
        .then(response => {
          if (response.data.data) {
            if (id) {
              commit('REMOVE_NETWORK_FIREWALL_ENTRY', id)
            }
            commit('ADD_NETWORK_FIREWALL_ENTRY', response.data.data)
            resolve(response)
          } else {
            reject(response.data.error)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  deleteNetworkIPFirewallEntry({ commit }, { network_id, entry_id }) {
    return new Promise((resolve, reject) => {
      network
        .deleteFirewallEntry(network_id, entry_id)
        .then(response => {
            commit('REMOVE_NETWORK_FIREWALL_ENTRY', entry_id)
            resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  fetchNetworkASNEntries({ commit }, network_id) {
    return new Promise((resolve, reject) => {
      network
        .getNetworkASNEntries(network_id)
        .then(response => {
          commit('SET_NETWORK_ASN_ENTRIES', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  createOrUpdateNetworkASNEntry({ commit }, { network_id, asn, whitelist, id }) {
    return new Promise((resolve, reject) => {
      network
        .createOrUpdateNetworkASNEntry(network_id, asn, whitelist, id)
        .then(response => {
          if (response.data.data) {
            if (id) {
              commit('REMOVE_NETWORK_ASN_ENTRY', id)
            }
            commit('ADD_NETWORK_ASN_ENTRY', response.data.data)
            resolve(response)
          } else {
            reject(response.data.error)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  deleteNetworkASNEntry({ commit }, { network_id, entry_id }) {
    return new Promise((resolve, reject) => {
      network
        .deleteNetworkASNEntry(network_id, entry_id)
        .then(response => {
          commit('REMOVE_NETWORK_ASN_ENTRY', entry_id)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  fetchNetworkCountryEntries({ commit }, network_id) {
    return new Promise((resolve, reject) => {
      network
        .getNetworkCountryEntries(network_id)
        .then(response => {
          commit('SET_NETWORK_COUNTRY_ENTRIES', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  createOrUpdateNetworkCountryEntry({ commit }, { network_id, country_id, whitelist, id }) {
    return new Promise((resolve, reject) => {
      network
        .createOrUpdateNetworkCountryEntry(network_id, country_id, whitelist, id)
        .then(response => {
          if (response.data.data) {
            if (id) {
              commit('REMOVE_NETWORK_COUNTRY_ENTRY', id)
            }
            commit('ADD_NETWORK_COUNTRY_ENTRY', response.data.data)
            resolve(response)
          } else {
            reject(response.data.error)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  deleteNetworkCountryEntry({ commit }, { network_id, entry_id }) {
    return new Promise((resolve, reject) => {
      network
        .deleteNetworkCountryEntry(network_id, entry_id)
        .then(response => {
          commit('REMOVE_NETWORK_COUNTRY_ENTRY', entry_id)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  fetchAllCountries() {
    return new Promise((resolve, reject) => {
      network
        .fetchAllCountries()
        .then(response => {
          if (response.data.data) {
            resolve(response)
          } else {
            reject(response.data.error)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },

}
